module.exports = __webpack_public_path__ + "img/g4.52ceb12b.jpg";